window._bpUpdateQty = function (item, index, direction) {
  var step = parseInt(item.properties && item.properties['_bp_qty_step'], 10) || 1;
  var current = parseInt(item.quantity, 10) || step;
  var next = current + (direction * step);
  if (next < step) next = step;

  if (window.app) window.app.isLoading = true;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ quantity: next, line: index })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (window.app && typeof window.app._getCartData === 'function') {
        window.app._getCartData();
        window.app.isLoading = false;   // ← added this line
      } else {
        window.location.reload();
      }
    })
    .catch(function (err) {
      console.warn('[BarkPotty] quantity update failed', err);
      if (window.app) window.app.isLoading = false;
    });
};